import { useCallback, useEffect, useRef, useState } from "react";
import { useApi } from "../../lib/api";

let scriptPromise;
function loadTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      const timer = setTimeout(() => fail(), 20000);
      function fail() {
        clearTimeout(timer);
        script.remove();
        reject(new Error("Spam-Schutz konnte nicht geladen werden."));
      }
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.onload = () => {
        clearTimeout(timer);
        if (window.turnstile) resolve(window.turnstile);
        else fail();
      };
      script.onerror = fail;
      document.head.appendChild(script);
    }).catch((error) => { scriptPromise = null; throw error; });
  }
  return scriptPromise;
}

function SpamProtection({ config, loading, error, reload, onToken, resetKey }) {
  const container = useRef(null);
  const [problem, setProblem] = useState("");
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    if (!config?.enabled) return;
    let alive = true;
    let widget;
    setProblem("");
    onToken("");
    loadTurnstile().then((turnstile) => {
      if (!alive || !container.current) return;
      widget = turnstile.render(container.current, {
        sitekey: config.site_key,
        action: "form",
        language: "de",
        size: "flexible",
        "response-field": false,
        callback: (token) => { if (alive) { setProblem(""); onToken(token); } },
        "expired-callback": () => { if (alive) onToken(""); },
        "timeout-callback": () => { if (alive) onToken(""); },
        "error-callback": () => {
          if (alive) { onToken(""); setProblem("Spam-Schutz konnte nicht bestätigt werden. Bitte erneut versuchen."); }
        },
      });
    }).catch(() => {
      if (alive) { onToken(""); setProblem("Spam-Schutz konnte nicht geladen werden. Bitte Verbindung oder Inhaltsblocker prüfen."); }
    });
    return () => {
      alive = false;
      if (widget !== undefined && window.turnstile) window.turnstile.remove(widget);
    };
  }, [config?.enabled, config?.site_key, onToken, resetKey, retry]);
  if (loading) return <p className="text-sm" role="status">Spam-Schutz wird geladen …</p>;
  if (error || problem) return <div className="text-sm space-y-2" role="alert"><p>{problem || "Spam-Schutz derzeit nicht verfügbar. Bitte erneut versuchen oder WhatsApp nutzen."}</p><button type="button" className="underline" onClick={() => { onToken(""); setProblem(""); setRetry((n) => n + 1); reload(); }}>Erneut versuchen</button></div>;
  if (!config?.enabled) return null;
  return <div ref={container} className="min-h-[65px] w-full" aria-label="Spam-Schutz von Cloudflare" />;
}

export function useSpamProtection() {
  const { data, loading, error, reload } = useApi("/public/security");
  const [token, setToken] = useState("");
  const [resetKey, setResetKey] = useState(0);
  const reset = useCallback(() => { setToken(""); setResetKey((n) => n + 1); }, []);
  return {
    token,
    ready: !loading && !error && !!data && (!data.enabled || !!token),
    reset,
    widget: <SpamProtection config={data} loading={loading} error={error} reload={reload} onToken={setToken} resetKey={resetKey} />,
  };
}
